import React, {useState, useEffect} from "react";
import * as Icons from "react-feather"

export default function DarkMode() {
   const [isEnabled, setIsEnabled] = useState(false);

   useEffect(() => {
      if (localStorage.getItem("theme") != "dark") {
         document.documentElement.classList.add("light");
         localStorage.setItem("theme", "light");
         setIsEnabled(false);
      } else {
         document.documentElement.classList.add("dark");
         localStorage.setItem("theme", "dark");
         setIsEnabled(true);
      }
   }, []);

   const handler = () => {
      let htmlClasses = document.querySelector("html").classList;
      if (localStorage.theme == "dark") {
         htmlClasses.remove("dark");
         htmlClasses.add("light");
         localStorage.setItem("theme", "light");
         setIsEnabled(false);
      } else {
         htmlClasses.add("dark");
         htmlClasses.remove("light");
         localStorage.setItem("theme", "dark");
         setIsEnabled(true);
      }
   };

   return (
      <>
         <div onClick={handler}
              className="mx-1 p-2 dark-mode-switcher cursor-pointer shadow-md box dark:bg-dark-2 border rounded-full flex items-center justify-center "
         >
            {!isEnabled && <div className="mx-2 text-gray-700 dark:text-gray-300"><Icons.Moon/></div>}
            <div className={`dark-mode-switcher__toggle border transition duration-300 ${
               isEnabled ? "dark-mode-switcher__toggle--active" : ""
            }`}
            ></div>
            {isEnabled && <div className="mx-1 text-gray-700 dark:text-gray-300"><Icons.Sun/></div>}
         </div>
      </>
   );
}
